import React from 'react';
import { Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';

export const slideTransition = (props: TransitionProps) => {
  return <Slide {...props} direction="down" />;
};
